import { i18n } from '@/i18n/bootstrap'
import { Locales } from '@/types'

export function registerTranslations(): void {
  return
}

export function setLocale(locale: string): void {
  (i18n.global.locale as unknown as { value: string }).value = locale
}

export function getLocale(): string {
  const loc = i18n.global.locale as unknown as { value: string } | string
  return String((typeof loc === 'object' ? loc.value : loc) || Locales.En)
}

export function getLocales(): string[] {
  return Object.values(Locales)
}

export function translate(key: string, args?: unknown[]): string {
  return String(i18n.global.t(key, args as any) || key)
}
